import React from 'react';

import Graphic from './images/graphic.svg';

import { StyledWithoutGraphic } from './style/StyledWithoutGraphic';

const NotGraphic = () => (
	<StyledWithoutGraphic>
		<img src={Graphic} alt="Ícone gráfico" width={180} />
		<div className="container-text">
			<p>
				Você selecionou fazer a campanha somente na rede de pesquisa do Google, o que é
				uma ótima escolha, parabéns!!
			</p>
			<p>
				Neste caso você não precisa completar as informações sobre a peça gráfica.<br />
				Clique em &quot;Próximo&quot; para continuar seu preenchimento.
			</p>
		</div>
	</StyledWithoutGraphic>
);

export default NotGraphic;
